
import { defineComponent } from "vue";
import {
  GetMetricData,
  GetMetric,
  SummaryTitleByMonth,
  NumberWithCommas,
  GetHighlight,
  ChangeOverTime,
  SourceURL,
  GetDateFromMonthYear,
} from "@/utils";
import Spinner from "@/components/Spinner.vue";
import ChartOptions from "@/types/chartOptions";
import LineChart from "@/components/Chart/LineChart.vue";
import MetricSource from "@/components/MetricSource.vue";

export default defineComponent({
  data() {
    return {
      unemployTopic: "Unemployment",
      unemployProp: "unemployment_rate_mi",
      unemployRate: "",
      unemployMonthChange: "",
      unemployYearChange: "",
      unemployMetric: {},
      unemployData: [],
      unemployOptions: new ChartOptions(),
      unemployDataLabels: ["MI Rate", "US Rate"],
      unemployDataProps: ["unemployment_rate_mi", "unemployment_rate_us"],

      payrollJobsTopic: "PayrollJobs",
      payrollJobsProp: "payroll_jobs_mi",
      payrollJobsRate: "",
      payrollJobsMonthChange: "",
      payrollJobsYearChange: "",
      payrollJobsMonthChangeNum: 0,  
      payrollJobsYearChangeNum: 0,
      payrollJobsMetric: {},
      payrollJobsData: [],
      payrollJobsOptions: new ChartOptions(),
      payrollJobsDataLabels: ["MI"],
      payrollJobsDataProps: ["payroll_jobs_mi"],

      laborForceTopic: "LaborForceParticipation",
      laborForceProp: "labor_force_participation_rate_mi",
      laborForceRate: "",
      laborForceMonthChange: "",
      laborForceYearChange: "",
      laborForceMetric: {},
      laborForceData: [],
      laborForceOptions: new ChartOptions(),
      laborForceDataLabels: ["MI Labor Force Participation"],
      laborForceDataProps: ["labor_force_participation_rate_mi"],
    };
  },
  components: {
    Spinner,
    LineChart,
   // MetricSource,
  },

  methods: {
    sourceUrl(code: string) {
      return SourceURL(code);
    },
  },

  async beforeMount() {
    this.unemployMetric = GetMetric(this.unemployTopic); // Get metric configuration
    this.payrollJobsMetric = GetMetric(this.payrollJobsTopic);
    this.laborForceMetric = GetMetric(this.laborForceTopic);

    this.unemployData = await GetMetricData(this.unemployTopic);
    this.payrollJobsData = await GetMetricData(this.payrollJobsTopic);
    this.laborForceData = await GetMetricData(this.laborForceTopic);
    this.unemployOptions.events = ["resize"];

    // Unemployment data
    this.unemployRate = (
      Number(
        this.unemployData[this.unemployData.length - 1][this.unemployProp]
      ) * 100
    ).toFixed(1);
    this.unemployMonthChange = (
      Number(ChangeOverTime(this.unemployData, 1, this.unemployProp, false)) *
      100
    )
      .toFixed(1)
      .toString();
    this.unemployYearChange = (
      Number(ChangeOverTime(this.unemployData, 12, this.unemployProp, false)) *
      100
    )
      .toFixed(1)
      .toString();
    this.unemployOptions.scales.yAxis.ticks.callback = (label: any) => {
      return (label * 100).toFixed(1) + "%";
    };

    // Payroll jobs data
    this.payrollJobsMonthChangeNum = Number(ChangeOverTime(this.payrollJobsData, 1, this.payrollJobsProp, false)); 
    this.payrollJobsYearChangeNum = Number(ChangeOverTime(this.payrollJobsData, 12, this.payrollJobsProp, false));
    this.payrollJobsRate = NumberWithCommas(
      Number(
        this.payrollJobsData[this.payrollJobsData.length - 1][
          this.payrollJobsProp
        ]
      ).toFixed(0)
    );
    this.payrollJobsMonthChange = NumberWithCommas(
      this.payrollJobsMonthChangeNum
    );
    this.payrollJobsYearChange = NumberWithCommas(
      this.payrollJobsYearChangeNum
    );
    this.payrollJobsOptions.scales.yAxis.display = false;
    this.payrollJobsOptions.scales.xAxis.display = false;
    this.payrollJobsOptions.plugins.legend.display = false;
    this.payrollJobsOptions.events = [];

    // Labor force data
    this.laborForceRate = (
      Number(
        this.laborForceData[this.laborForceData.length - 1][this.laborForceProp]
      ) * 100
    ).toFixed(1);
    this.laborForceMonthChange = (
      Number(
        ChangeOverTime(this.laborForceData, 1, this.laborForceProp, false)
      ) * 100
    ).toFixed(1);
    this.laborForceYearChange = (
      Number(
        ChangeOverTime(this.laborForceData, 12, this.laborForceProp, false)
      ) * 100
    ).toFixed(1);
    this.laborForceOptions.scales.yAxis.display = false;
    this.laborForceOptions.scales.xAxis.display = false;
    this.laborForceOptions.plugins.legend.display = false;
    this.laborForceOptions.events = [];
  },
});
